// extracted by mini-css-extract-plugin
module.exports = {"digits":"_3u0G9zEV flex","digit-field":"kjX3XCbm mr2","digitField":"kjX3XCbm mr2","digit-input":"_1COy5ksI center","digitInput":"_1COy5ksI center"};